import { toLatinDigits } from './digits.js';

const ARABIC_RANGES =
  /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/u;
const LATIN_LETTER = /[A-Za-z]/;

const LATIN_NAME_EXTRA = /[0-9\s\-.,&'()]/;

export function filterLatinName(value: string): string {
  let out = '';
  for (const ch of value) {
    if (ARABIC_RANGES.test(ch)) continue;
    if (LATIN_LETTER.test(ch) || LATIN_NAME_EXTRA.test(ch)) out += ch;
  }
  return out;
}

export function filterArabicName(value: string): string {
  let out = '';
  for (const ch of value) {
    if (LATIN_LETTER.test(ch)) continue;
    if (ARABIC_RANGES.test(ch) || /[\s\-.,&'()0-9]/.test(ch)) out += ch;
  }
  return out;
}

export function isValidLatinName(value: string): boolean {
  const t = value.trim();
  if (!t) return false;
  return filterLatinName(t) === t && LATIN_LETTER.test(t);
}

export function isValidArabicName(value: string): boolean {
  const t = value.trim();
  if (!t) return true;
  return filterArabicName(t) === t && ARABIC_RANGES.test(t);
}

/** Account codes: Latin letters, digits, common separators only. */
export function filterAccountCode(value: string): string {
  return toLatinDigits(value).replace(/[^A-Za-z0-9\-_.]/g, '');
}
